<app-title-header
  [title]="viewMode ? caseIdentifier : ('title.case.create_new' | translate)"
  [description]="caseTitle"
  [iconClass]="viewMode ? 'bi bi-arrow-left' : 'bi bi-pencil'"
  [iconLink]="viewMode ? backButtonLink : ''"
  [viewMode]="viewMode"
>
  @if(viewMode && caseForm.dirty && !isInitializingForm) {
    <ng-container *ngTemplateOutlet="submitCaseActions; context: { isEdit: true }"></ng-container>
  }
</app-title-header>

@if(viewMode) {
<app-tabs-with-content [tabs]="tabs" [selectedTab]="selectedTab"
  (onSelectTab)="onSelectedTab($event)"></app-tabs-with-content>

  @if(lockUser && !lockUser.isEditable && (isAdmin || (!isAdmin && !isCaseClosed)) ) {
    <app-alert-notification [type]="'warning'" [iconClass]="'bi bi-lock'" [text]="'messages.ticket_locked_by_other_user' | translate: { user: lockUser.userFullName }">
    </app-alert-notification>
  }

  @if(escalationData && escalationData.isEscalated) {
    <app-alert-notification [type]="'danger'" [iconClass]="'bi bi-exclamation-triangle'" [text]="'messages.ticket_escaleted_alert_message'">
      @if(!caseForm.disabled) {
        <div class="banner-btn-container">
          <button class="btn banner-button" (click)="deEscalateCase()">{{ 'buttons.de_escalate' | translate }}</button>
        </div>
      }
    </app-alert-notification>
  }

  @if(displaySurveyBanner) {
    <app-alert-notification [type]="'info'" [iconClass]="'bi bi-question-diamond'" [text]="'messages.this_ticket_is_closed_survey'">
      <div class="banner-btn-container">
        <button class="btn banner-button" (click)="openSurvey()">{{ 'buttons.take_survey' | translate }}</button>
      </div>
    </app-alert-notification>
  }
}

<div [hidden]="loading">
  <div [hidden]="selectedTab !== tabs[0]">
    <div class="row">
      <form [formGroup]="caseForm" class="col-12" [ngClass]="{'col-lg-7 custom-left-side-panel': viewMode}">
        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.customer_details'">
          <app-customer-details-form
            [extended]="extended"
            [viewMode]="viewMode"
            [caseId]="caseId"
            [case]="caseObject"
           ></app-customer-details-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.problem_details'">
          <app-problem-details-form
            [extended]="extended"
            [viewMode]="viewMode"
            [severityItems]="severityItems"
            [caseId]="caseId"
            [uploadedFiles]="uploadedFiles"
          ></app-problem-details-form>
        </app-case-form-section-container>

        @if(viewMode) {
          <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.resolution_and_containment'">
            <app-case-resolution-containment-form
              [viewMode]="viewMode"
              [showVerifiedKnowledge]="showVerifiedKnowledge"
              [caseStage]="caseStage"
              [productCompany]="caseForm.get('productCompany')?.value"
              [productSuite]="caseForm.get('productSuite')?.value"
            ></app-case-resolution-containment-form>
          </app-case-form-section-container>
        }

        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.product_details'">
          <app-product-details-form
            [caseId]="caseId"
            [extended]="extended"
            [viewMode]="viewMode"
            [case]="caseObject"
          ></app-product-details-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.product_details_eparts'">
          <app-product-details-eparts-form
            [viewMode]="viewMode"
          ></app-product-details-eparts-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.process_details'">
          <app-process-details-form
            [viewMode]="viewMode"
            [case]="caseObject"
          ></app-process-details-form>
        </app-case-form-section-container>
        @if(!viewMode) {
        <app-case-form-section-container [iconClass]="'bi bi-buildings'" [title]="'label.interested_parties'">
          <app-interested-parties-form [viewMode]="viewMode"></app-interested-parties-form>
        </app-case-form-section-container>
        }
      </form>
      <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>

    </div>

    @if(!viewMode) {
      <ng-container *ngTemplateOutlet="submitCaseActions"></ng-container>
    }
  </div>

  <div class="row" [hidden]="selectedTab !== tabs[1]">
    <form [formGroup]="caseForm.get('caseRecord')" class="col-12" [ngClass]="{'col-lg-7 custom-left-side-panel': viewMode}">
      <app-case-form-section-container [iconClass]="'bi bi-info-circle'" [title]="'label.product_company'">
        <app-case-record-product-company-form
          [viewMode]="viewMode"
        ></app-case-record-product-company-form>
      </app-case-form-section-container>

      <app-case-form-section-container [iconClass]="'bi bi-info-circle'" [title]="'label.apps'">
        <app-case-record-apps-form [viewMode]="viewMode"></app-case-record-apps-form>
      </app-case-form-section-container>

      <app-case-form-section-container [iconClass]="'bi bi-info-circle'" [title]="'label.stc'">
        <app-case-record-stc-form
          [viewMode]="viewMode"
        ></app-case-record-stc-form>
      </app-case-form-section-container>
    </form>
    <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
  </div>

  @if(selectedTab === tabs[2]) {
    <div class="row">
      <div class="col-12" [ngClass]="{'col-lg-7 custom-left-side-panel': viewMode}">
        <app-case-comments [caseType]="caseType" [caseId]="caseId" [commentsFilterForm]="commentsFilterForm" [disabled]="isCaseClosed && !isAdmin"></app-case-comments>
      </div>
      <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
    </div>
  }

  @if(selectedTab === tabs[3]) {
    <div class="row">
      <div class="col-12" [ngClass]="{'col-lg-7 custom-left-side-panel': viewMode}">
        <app-case-history [tabs]="historyTabs" [translationPrefix]="'case.'"></app-case-history>
      </div>
      <ng-container *ngTemplateOutlet="formRightSidePanel"></ng-container>
    </div>
  }
</div>

<ng-template #formRightSidePanel>
  @if(viewMode) {
    <div class="col-12 col-lg-5 custom-right-side-panel">
      <form [formGroup]="caseForm">
        <app-case-form-section-container [iconClass]="'bi bi-info-circle'" [title]="'label.ticket_info'">
          <app-ticket-info-form
            [severityItems]="severityItems"
            [statusItems]="statusItems"
          ></app-ticket-info-form>
        </app-case-form-section-container>

        <app-case-form-section-container [hidden]="!escalationData" [iconClass]="'bi bi-exclamation-triangle-fill text-danger'" [title]="'label.escalation'">
           <app-escalation-form></app-escalation-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-activity'" [title]="'label.activity'">
          <app-activity-form
            [caseStageItems]="caseStageItems"
            [actionStatusItems]="actionStatusItems"
            [caseStatus]="caseStatus"
            [currentCaseStage]="currentCaseStage"
            [nextActionValidators]="nextActionValidators"
            [caseObject]="caseObject"
          ></app-activity-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-people-fill'" [title]="'label.case_team'">
          <app-case-team-form [caseObject]="caseObject" (onTicketOwnerChange)="setNextActionValidators($event ? $event.id : $event)"></app-case-team-form>
        </app-case-form-section-container>

        <app-case-form-section-container [iconClass]="'bi bi-people-fill'" [title]="'label.interested_parties'">
          <app-interested-parties-form [viewMode]="viewMode"></app-interested-parties-form>
        </app-case-form-section-container>


      </form>
      <form [formGroup]="linksForm">
        <app-case-form-section-container [iconClass]="'bi bi-link'" [rightIconClass]="linksEditable ? linksEditMode ? 'bi bi-floppy2-fill text-success' : 'bi bi-pencil' : ''" [title]="'label.links'" [iconDisabled]="linksForm.invalid" (onClickRightIcon)="submitLinks($event)">
          <app-case-links [editMode]="linksEditMode"></app-case-links>
        </app-case-form-section-container>
      </form>
    </div>
  }
</ng-template>

<ng-template #submitCaseActions let-isEdit="isEdit">
  <div class="submit-actions">
    <button class="btn secondary-button" (click)="onLeaveCase()">{{ 'label.cancel' | translate }}</button>
    <button
      class="btn primary-button"
      (click)="submitForm(isEdit)"
      translate="{{viewMode ? 'label.update_ticket' : 'label.submit_ticket'}}"
    ></button>
  </div>
</ng-template>

<app-chat-dialog *ngIf="viewMode && isChatAvailable && !isSurvey && !this.isCaseClosed" [caseId]="caseId" (onSeeAllThreads)="navigateToCommentsTab()"></app-chat-dialog>
@if(displaySurveyBanner) {
  <app-case-closure-survey [isOpen]="isSurvey" [caseId]="caseId" [surveyTeam]="surveyTeam" (onClosePanel)="closeSurvey($event)"></app-case-closure-survey>
}
